import React, { useEffect, useState } from 'react'
import styles from "./Dashboardheader.module.css"
import { HashLink } from 'react-router-hash-link';
import { Link, useParams } from 'react-router-dom'

import ThemeButton from '../../Themes/ThemeButton'
import { useTheme } from '../../Themes/ThemeContext'
import { divide } from 'lodash'

const Dashboardheader = () => {
    const { theme } = useTheme();
    const [isMobile, setIsMobile] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
    const handleResize = () => {
            if (window.innerWidth < 770) {
                setIsMobile(true);
            }else{
                setIsMobile(false);
            }
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    return (
        <div className={styles.dashboardnavbarcontainer}>
            <Link to={"/home"}>
                {
                    theme === "dark" ? (
                        <img src={process.env.PUBLIC_URL + "/NewPages/Dashboard/darklogo.png"} />
                    ) :
                        <img src={process.env.PUBLIC_URL + "/NewPages/Homepage/TransformaLogo.png"} />
                }
            </Link>
            {
                !isMobile && (<>
                    <div className={styles.dashboardnavbarlinks}>
                        <ul>
                            <li><HashLink smooth to="/home#features">Features</HashLink></li>
                            <li><Link to={"/templates"}>Templates</Link></li>
                            <li><HashLink smooth to="/home#pricing">Pricing</HashLink></li>
                            <li><HashLink smooth to="/home#faqs">FAQS</HashLink></li>
                        </ul>
                    </div>
                </>)
            }
            {
                isMobile && (
                    <>
                        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>

                            <svg width="30" height="30" viewBox="0 0 100 80" fill="currentColor">
                                <rect width="100" height="10"></rect>
                                <rect y="30" width="100" height="10"></rect>
                                <rect y="60" width="100" height="10"></rect>
                            </svg>
                        </button>
                    </>
                )
            }
            {
                (isMobile && mobileMenuOpen) && (
                    <div className={styles.mobile_menu_links}>
                        <ul>
                            <li><HashLink smooth to="/home#features">Features</HashLink></li>
                            <li><Link to={"/templates"}>Templates</Link></li>
                            <li><HashLink smooth to="/home#pricing">Pricing</HashLink></li>
                            <li><HashLink smooth to="/home#faqs">FAQS</HashLink></li>

                        </ul>
                    </div>
                )
            }

        </div>
    )
}

export default Dashboardheader